import MainLayout from 'layouts/MainLayout';

import PrivacyCheck from 'pages/Tools/PrivacyCheck';
import CompanyMappingStart from 'pages/Tools/CompanyMappingStart';
import CompanyMapping from 'pages/Tools/CompanyMapping';
import CompanyMappingPresentation from 'pages/Tools/CompanyMappingPresentation';
import AssistantCreator from 'pages/Tools/AssistantCreator';
import AITrainer from 'pages/Tools/AITrainer';

const routes = [{
    layout: MainLayout,
    routes: [{
        path: '/tools/privacy-check',
        element: PrivacyCheck,
        exact: true,
        analytics: { name: ["Tools", "Privacy Check"] },
    }, {
        path: '/tools/company-mapping',
        element: CompanyMappingStart,
        exact: true,
        analytics: { name: ["Tools", "Mappatura Aziendale"] },
    }, {
        path: '/tools/company-mapping/:conversationId',
        element: CompanyMapping,
        exact: true,
        analytics: { name: ["Tools", "Mappatura Aziendale", "Conversazione"] },
    }, {
        path: '/tools/company-mapping/:conversationId/presentation',
        element: CompanyMappingPresentation,
        exact: true,
        analytics: { name: ["Tools", "Mappatura Aziendale", "Presentazione"] },
    }, {
        path: '/tools/assistant-creator',
        element: AssistantCreator,
        exact: true,
        analytics: { name: ["Tools", "Creatore Assistenti"] },
    }, {
        path: '/tools/ai-trainer',
        element: AITrainer,
        exact: true,
        analytics: { name: ["Tools", "Formatore AI"] },
    }]
}]

export default routes;
